<template>
  <b-dropdown ref="dropdown" position="is-bottom-left">
    <button class="button" slot="trigger">
      <b-icon icon="clock"></b-icon>
      <slot></slot>
    </button>

    <div class="dropdown-item" style="width: 300px;">
      <b-field :label="$tc('dater.range')" size="is-small">
        <b-select v-model="options.date_range" expanded>
          <option value="all_time">All Time</option>
          <option value="last_15_days">Last 15 days</option>
          <option value="today">Today</option>
          <option value="yesterday">Yesterday</option>
          <option value="this_week">This week</option>
          <option value="last_week">Last week</option>
          <option value="this_month">This month</option>
          <option value="last_month">Last month</option>
          <option value="this_year">This year</option>
          <option value="last_year">Last year</option>
          <option value="custom">Custom date range</option>
        </b-select>
      </b-field>

      <div class="columns" v-if="options.date_range === 'custom'">
        <div class="column">
          <b-field label="Start Date">
            <datepicker v-model="options.start_date"></datepicker>
          </b-field>
        </div>

        <div class="column">
          <b-field label="End Date">
            <datepicker v-model="options.end_date"></datepicker>
          </b-field>
        </div>
      </div>

      <b-field v-if="withInterval" label>
        <b-radio-button :disabled="onlyDayInterval" v-model="options.interval" native-value="hour" size="is-small">
          <span>Hourly</span>
        </b-radio-button>

        <b-radio-button :disabled="onlyDayInterval" v-model="options.interval" native-value="day" size="is-small">
          <span>Daily</span>
        </b-radio-button>

        <b-radio-button :disabled="onlyDayInterval" v-model="options.interval" native-value="week" size="is-small">
          <span>Weekly</span>
        </b-radio-button>

        <b-radio-button :disabled="onlyDayInterval" v-model="options.interval" native-value="month" size="is-small">
          <span>Monthly</span>
        </b-radio-button>

        <b-radio-button :disabled="onlyDayInterval" v-model="options.interval" native-value="year" size="is-small">
          <span>Yearly</span>
        </b-radio-button>
      </b-field>

      <b-field v-if="displayTypeFiltering" label="Display data" size="is-small">
        <b-select v-model="options.showtype">
          <option value="percent">by percents</option>
          <option value="count">by counts</option>
        </b-select>
      </b-field>

      <button class="button is-primary is-outlined" @click="submit">Search</button>
    </div>
  </b-dropdown>
</template>

<script>
import _ from "lodash";

export default {
  props: {
    onlyDayInterval: {
      type: Boolean,
      default: false
    },

    withInterval: {
      type: Boolean,
      default: true
    },
    displayTypeFiltering: {
      type: Boolean,
      default: false,
    }
  },

  data() {
    return {
      options: {
        date_range: this.$route.query.date_range || "last_15_days",
        interval: "day",
        showtype: 'percent'
      }
    };
  },

  watch: {
    "$route.query.date_range"(dateRange) {
      this.options.date_range = dateRange;

      this.submit(false);
    }
  },

  methods: {
    submit(toggle = true) {
      let options = _.clone(this.options);

      if (options.date_range == "custom") {
        options.date_range = options.start_date + "," + options.end_date;
      }

      this.$emit("submit", options);

      if (toggle) {
        this.$refs.dropdown.toggle();
      }
    }
  }
};
</script>
